const LastYear = () => {
  return <div></div>;
};

export { LastYear };
